import axios from "axios";
import Router from './router.js'
import {Loading, Message} from 'element-ui';

let loading;
const closeLoading = () => {
    if (loading) {
        loading.close();
    }
};

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = process.env.VUE_APP_HOST;

const _axios = axios.create({});
_axios.interceptors.request.use(
    function (config) {
        const token = sessionStorage.getItem("auth-token");
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }

        loading = Loading.service({
            spinner: 'el-icon-loading',
            background: "rgba(0, 0, 0, 0.1)"
        });
        return config;
    },
    function (error) {
        closeLoading();
        return Promise.reject(error);
    }
);

_axios.interceptors.response.use(
    function (response) {
        closeLoading();
        let data = response.data;
        if (typeof data === "object" && 'code' in data && data['code'] !== 0) {
            Message.error(data['msg']);
        }
        return data;
    },
    function (error) {
        closeLoading();

        let response = error.response;
        if (response) {
            Message.closeAll();

            switch (response.status) {
                case 401:
                    Message.error("身份验证失败，请重新登录或联系管理员。");
                    sessionStorage.removeItem("auth-token");
                    Router.push("/login");
                    break;
                case 403:
                    Message.error("您不具有访问该服务的权限！");
                    break;
                case 404:
                    Message.error("请求地址不存在！");
                    break;
                default:
                    console.log(response);
                    break;
            }
        }
        return Promise.reject(error);
    }
);

export default _axios;